import Vue from 'vue'
import Antd from 'ant-design-vue'

/* Variable for change default antd themes */
import './antd-variables.less'
Vue.use(Antd)
